import { Platform } from '@acre-rewards/lib'
import * as Stores from '../stores'
import { useIsUserSignedIn } from '@/src/common/hooks/useIsUserSignedIn'

export const useGetFirstAccount = () => {
  // todo: extract this into a `useLoggedInQuery` hook similar to the grpahql version in src/common/gql/MesaGql/index.ts
  const { isSignedInWithPhoneNumber } = useIsUserSignedIn()

  return Stores.CardAccountsApi.endpoints['GET /card/accounts'].useQuery(
    { query: { limit: 1 } },
    {
      skip: !isSignedInWithPhoneNumber,
      selectFromResult({ data, isLoading, isSuccess, error, isUninitialized }) {
        return {
          isUninitialized,
          isLoading,
          isSuccess,
          error,
          data:
            isSuccess && data.length !== 0 && data[0]?.id
              ? ({ platform: Platform.enum.LOANPRO, id: data[0].id } as const)
              : isSuccess
                ? ({ platform: Platform.enum.HIGHNOTE } as const)
                : undefined,
        }
      },
    },
  )
}
